import { render, staticRenderFns } from "./LoaderSpinner.vue?vue&type=template&id=2dabb1de"
import script from "./LoaderSpinner.vue?vue&type=script&lang=js"
export * from "./LoaderSpinner.vue?vue&type=script&lang=js"
import style0 from "./LoaderSpinner.vue?vue&type=style&index=0&id=2dabb1de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports